export default "__VITE_ASSET__BuVi0Sp8__"